export const reportConstants = {

    GET_LEAD_AND_SALE_OPPORTUNITY_REPORT_REQUEST: 'GET_LEAD_AND_SALE_OPPORTUNITY_REPORT_REQUEST',
    GET_LEAD_AND_SALE_OPPORTUNITY_REPORT_SUCCESS: 'GET_LEAD_AND_SALE_OPPORTUNITY_REPORT_SUCCESS',
    GET_LEAD_AND_SALE_OPPORTUNITY_REPORT_FAILURE: 'GET_LEAD_AND_SALE_OPPORTUNITY_REPORT_FAILURE',
    GET_MANAGER_REPORT_REQUEST: 'GET_MANAGER_REPORT_REQUEST',
    GET_MANAGER_REPORT_SUCCESS: 'GET_MANAGER_REPORT_SUCCESS',
    GET_MANAGER_REPORT_FAILURE: 'GET_MANAGER_REPORT_FAILURE',

}
